import { BOOKINGURL } from "helpers/constant";
import { callApi } from "Apis";

// Booking List Data API
export async function bookingList(data) {
  try {
    const response = await callApi({ url: BOOKINGURL.LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Add Bookind API
export async function addBooking(data) {
  try {
    const response = await callApi({ url: BOOKINGURL.ADD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Get By Id API
export async function getBookingById(id) {
  try {
    const response = await callApi({ url: BOOKINGURL.GET(id), method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}

// Update Booking API
export async function updateBookingById(data) {
  try {
    const response = await callApi({ url: BOOKINGURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}

//Delete Booking API
export async function deleteBookingById(id) {
  try {
    const response = await callApi({ url: BOOKINGURL.DELETE(id), method: "DELETE" });
    return response;
  } catch (err) {
    throw err;
  }
}
